// 简体
export default {
  locale: {
    zhHans: '简体',
    zhHant: '繁体'
  },
  index: {
    home: '首页',
    vote: '问卷调查',
    comment: '跟帖',
    me: '我的',
    personal: '我的信息',
    changePwd: '修改密码',
    collection: '收藏',
    notice: '通知',
    history: '历史',
    life: '商家',
    addlife: '商家发布',
    myaddlife: '我发布的商家信息',
    viewlife: '商家信息详情',
    recruit: '招聘',
    addrecruit: '发布招聘',
    myaddrecruit: '我发布的招聘',
    viewrecruit: '招聘详情',
    youknow: '易书',
    addyouknow: '发布易书',
    myaddyouknow: '我发布的易书',
    viewyouknow: '易书详情',
    commentonmy: '评论我的',
    praiseme: '点赞我的',
    icommented: '我评论的',
    ilikeit: '我点赞的',
    search: '搜索'
  },
  common: {
    morelist: '上拉加载更多',
    loading: '加载中',
    baseline: '我是有底线的',
    totop: '置顶',
    adv: '广告',
    nodata: '暂无数据'
  },
  home: {
    allcomments: '全部评论',
    nocomments: '目前还没有跟贴，欢迎您发表观点',
    reply: '回复: 说说你的见解'
  },
  form: {
    title: '标题',
    titleInput: '请输入标题',
    column: '所属类别',
    columnInput: '请选择所属类别',
    area: '所在城市',
    areaInput: '请选择地区',
    contact: '联系人',
    contactInput: '请输入联系人',
    phone: '联系电话',
    phoneInput: '请输入联系电话',
    EmailInput: '请输入Email',
    content: '内容描述',
    contentInput: '请输入内容描述',
    uploadImg: '图片',
    uploadImgUp: '请上传图片',
    okbutton: '确 定',
    okbutton2: '立即发布',
    addsuccess: '发布成功',
    editsuccess: '修改成功',
    wanttorecruit: '我要招聘',
    recruitposition: '请输入招聘岗位',
    salary: '薪资',
    salaryType: '薪资类别',
    entersalary: '请输入薪资',
    Industry: '所属行业',
    selectindustry: '请选择所属行业',
    education: '学历',
    selectdegree: '请选择学历',
    experience: '工作经验',
    selectexperience: '请选择工作经验',
    region: '所属地区',
    selectregion: '请选择所属地区',
    workplace: '工作地点',
    enterplace: '请输入工作地点',
    numberrecruiters: '招聘人数',
    enternumberrecruiters: '请输入招聘人数',
    recruitmentType: '招聘类型',
    selectrecruittype: '请选择招聘类型',
    positionDescription: '职位描述',
    enterjobdescription: '请输入职位描述',
    benefits: '福利待遇',
    enterbenefits: '请输入福利待遇',
    companyname: '公司名称',
    entercompanyname: '请输入公司名称',
    companyProfile: '公司简介',
    entercompanyprofile: '请输入公司简介',
    unlimited: '不限',
    fulltime: '全职',
    parttime: '兼职',
    Internship: '实习',
    region2: '地区',
    category: '类别',
    All: '全部',
    time: '时间',
    '3daysago': '3天前',
    '7daysago': '7天前',
    '1monthago': '1个月前',
    longago: '很久以前',
    browse: '浏览',
    like: '点赞',
    comment: '评论',
    release: '发布',
    offshelf: '已下架',
    indisplay: '显示中',
    operation: '操作',
    putshelf: '上架',
    modify: '修改',
    details: '详情',
    delete: '删除',
    remove: '下架',
    weiguan: '人围观',
    positionDetails: '职位详情',
    popularPosition: '热门职位',
    applyPosition: '申请职位',
    source: '来源'
  },
  login: {
    inputpassword: '请输入密码',
    forgotpassword: '忘记密码',
    enteremail: '请输入邮箱',
    entervercode: '请输入邮箱验证码',
    newpassword: '请输入新的登录密码',
    submit: '提交',
    sendvercode: '发送验证码',
    sentEmailsuccess: '邮箱验证码发送成功',
    resend: '重新发送',
    enteremailaddress: '请输入邮箱地址',
    enternewpassword: '请输入新密码',
    tologinpage: '修改成功即将跳转到登录页',
    mailboxnotempty: '邮箱不能为空',
    formatincorrect: '邮箱格式不正确',
    skip: '跳过',
    accountLogin: '账号登录',
    enterloginpassword: '请输入登录密码',
    loginnow: '立即登录',
    registerNow: '立即注册',
    register: '注册',
    enternickname: '请输入昵称',
    selectgender: '请选择性别',
    viewandagree: '查看并同意',
    termsofUse: '使用条款',
    privacyPolicy: '隐私政策',
    existAccount: '已有账号',
    directLogin: '直接登录',
    successregistered: '注册成功，即将跳转到登录页',
    check: '请勾选查看并同意《使用条款》《隐私政策》！'
  },
  me: {
    integral: '积分',
    platform: '商家、招聘、易书等信息交流平台',
    commonfunctions: '常用功能',
    message: '消息',
    basicInfo: '基本信息',
    ersiovnUpdate: '版本更新',
    ersiovns: '版本号',
    logout: '退出登录',
    accountCancellate: '注销账户',
    publishedItems: '选择发布的项目',
    cancellationSucceeded: '账户注销成功',
    originalPassword: '原密码',
    newPassword: '新密码',
    InputoriginalPassword: '请输入原密码',
    InputnewPassword: '请输入新密码',
    confirmPassword: '确认密码',
    enterNewPasswordAgain: '请再次输入新密码',
    enterConfirmationPassword: '请输入确认密码',
    modify: '确定要修改吗?',
    systemPrompt: '系统提示',
    logInAgain: '密码修改成功，请重新登录！',
    enteredInconsistent: '两次密码输入不一致！',
    changeAvatar: '点击更换头像',
    support: '单张图片最大支持5MB',
    operationSucceeded: '操作成功',
    operationFailed: '操作失败',
    tel: '手机号码',
    inputTel: '请输入手机号码',
    emial: '邮箱',
    nickname: '请输入昵称',
    gender: '性别',
    birthday: '生日',
    selectBirthday: '请选择生日',
    login: '登录',
    likeArticle: '文章赞',
    likeComments: '评论赞',
    keywords: '请输入搜索关键词',
    news: '新闻',
    selectCity: '请选择所在城市',
    reply: '回复',
    expand: '展开',
    replies: '条回复',
    popularComments: '热门评论',
    seemore: '点击查看更多',
    comment: '目前还没有跟贴，欢迎您发表观点',
    dial: '拨打',
    body: '正文',
    Likeit: '点赞成功',
    cancelLiking: '取消点赞',
    send: '发送',
    commentScuess: '评论成功',
    uploading: '上传中',
    inputing: '开始输入...',
    uploading2: '上传中...',
    uploading3: '正在上传中...'
  },
  plugn: {
    selectphoto: '选照片',
    deleteit: '确定删除吗?'
  },
  upload: {
    name: '点击上传',
    drag: '将文件拖到此处，或',
    file: '图片',  // 附件
    valid: '选择的文件格式不符合要求',
    limited: '当前限制选择',
    files: '个文件，本次选择了',
    allSelected: '个文件，共选择了',
    aFile: '个文件',
    restored: '确定移除吗？一旦删除，将无法恢复！',
    verify: '确认',
    cancel: '取消',
  },
  views: {
    titles: '广告详情',
    fan: '关注/粉丝数据',
    followed: '已关注',
    followStatus: '关注',
    unfollow: '确认不再关注',
    confirm: '确认关注?',
    successfully: '取消关注成功',
    focus: '关注成功',
    saved: '你收藏了该文章',
    zan: '你赞了该文章',
    zanArc: '你赞了该评论',
    fans: '粉丝',
    follow: '关注',
    liked: '赞过',
    likes: '获赞',
    comments: '我的评论',
    received: '收到的评论',
    history: '浏览记录',
    account: '账户设置',
    male: '男',
    female: '女',
    Preview: '预览',
    Circular: '圆形预览',
    available: '暂无预览',
    Square: '方形预览',
    update: '重新选择',
    format: '更新预览',
    uploaded: '图片格式错误！请选择 jpg、png、gif 格式的图片',
    exceed: '上传图片大小不能超过 5MB!',
    successful: '头像上传成功',
    failed: '头像上传失败: ',
    avatar: '裁剪头像',
    ok: '确定',
    published: '发布于',
    createbook: '发布易书笔记',
    editbook: '编辑易书笔记',
    detailbook: '易书笔记详情',
    contentPlaceholder: '请输入内容',
    imageUploading: '图片上传中...',
    imageUploadSuccess: '图片上传成功',
    imageUploadFailed: '图片上传失败：',
    imageTypeLimit: '只能上传图片文件',
    resetForm: '重置',
    newPublish: '新发布',
    threeDaysAgo: '3天内',
    sevenDaysAgo: '7天内',
    oneMonthAgo: '1个月内',
    longTimeAgo: '很久以前',
    bookList: '易书笔记列表',
    publishTime: '发布时间',
    statistics: '统计数据',
    confirmOffShelf: '确定要下架该商家吗？',
    youknowTip: '提示',
    confirmOnShelf: '确定要上架该商家吗？',
    onShelfSuccess: '上架成功',
    offShelfSuccess: '下架成功',
    confirmDelete: '确定要删除该商家吗？',
    deleteSuccess: '删除成功',
    imageLoading: '图片加载中...',
    cancelFollow: '取消关注',
    createadv: '发布商家广告',
    editadv: '编辑商家广告',
    detailadv: '商家广告详情',
    createmer: '发布招聘',
    updatemer: '编辑招聘',
    detailmer: '招聘详情',
    salary: '月薪',
    hourly: '时薪',
    recruitment: '招聘详情',
    occupation: '职业类型',
    allArea: '全部地区',
    months: '元/月',
    hours: '元/时',
    advertising: '广告',
    favorited: '已收藏',
    address: '工作地址',
    poster: '职位发布人',
    collected: '收藏成功',
    unsave: '取消收藏',
    merchant: '商家广告列表',
    recruitment: '招聘列表',
    category: '所属栏目',
    jobtype: '工作类型',
    guess: '猜你喜欢',
    featured: '热点精选',
    more: '更多',
    trading: '物品买卖',
    Latest: '最新新闻',
    immigration: '移民要闻',
    easyBooks: '热门易书',
    realEstate: '地产头条',
    finance: '财经资讯',
    jobHunting: '求职招聘',
    automotive: '汽车专题',
    interesting: '奇闻趣事',
    survey: '问卷调查',
    participants: '已有',
    peopleJoined: '人参与',
    getInfo: '获取信息',
    easierHere: '从这里更容易',
    welcomeLogin: '欢迎登录',
    loginBetter: '登录后内容更精彩',
    welcomeRegister: '欢迎注册',
    agreeRead: '我已经阅读并同意',
    userAgreement: '《用户协议》及《隐私条款》',
    passwordMismatch: '两个密码不一致',
    passwordLength: '密码长度在6到16个字符之间',
    sending: '发送中，请稍后...',
    searchNow: '立即搜索',
    searchFound: '共搜索到',
    relatedTo: '条与',
    pwd: '密码',
    vers: '验证码',
    newPwd: '请再次输入密码',
    nickname: '昵称',
    keys: '请输入关键词',
    infos: '相关的信息',
    aboutUs: '关于我们',
    serviceAgreement: '服务协议',
    adPlacement: '广告投放',
    clientDownload: '客户端下载',
    companyAddress: '公司地址',
    richmondHQ: '列治文总部',
    contactUs: '联系我们',
    businessCooperation: '商务合作',
    officialWebsite: '知易官网',
    shareTo: '分享到',
    weibo: '微博',
    qqZone: 'QQ空间',
    wechat: '微信',
    copyLink: '复制链接',
    cancel: '取消',
    wechatShare: '微信分享',
    scanQRCode: '请使用微信扫描二维码分享',
    commentsCount: '条评论',
    pleaseLoginFirst: '请先',
    afterLoginComment: '后再发表评论',
    commentNow: '立即评论',
    commentPlaceholder: '请输入您的评论...',
    noComments: '暂无评论',
    publishReply: '发布回复',
    linkCopied: '链接已复制到剪贴板',
    pleaseLogin: '请先登录',
    replyNotEmpty: '回复内容不能为空',
    replySuccess: '回复成功',
    replyFailed: '回复失败',
    cannotLikeAndDislike: '您不能同时对一篇文章又赞又踩哦',
    commentNotEmpty: '评论内容不能为空',
    commentFailed: '评论失败',
    delFailed: '删除失败',
    submitFailed: '确定要取消回复吗？内容将不会被保存。',
    copyFailed: '复制失败，请手动复制',
    interest: '搜索感兴趣的内容',
    release: '发布中心',
    menuItem: '互动消息',
    settingOption: '账号设置',
    actionButton: '更换密码',
    zhCN: '中文简体',
    zhTW: '中文繁体',
    outlogin: '确定要退出登录吗?',
    personal: '个人中心',
    merchantAds: '商家广告',
    adsList: '广告列表',
    publishAd: '发布广告',
    recruitmentInfo: '招聘信息',
    readingNotes: '易书笔记',
    notesList: '笔记列表',
    publishNote: '发布笔记',
    columnpublish: '请选择发布的栏目',
    housekeeping: '家政、装修、维修、搬运、二手、租房、卖房、租车、律师、教培、移民等',
    finance2: 'IT、金融、房地产、建筑、贸易、零售、物流、教育、传媒、服务业、市场等',
    exploration: '美食探店、美妆护肤、旅行、家居生活、情感、心理、职场、学习等',
    ranking: '热点排行',
    centers: '发布中心',
  }
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN.js